import React, { useEffect, useState } from 'react';
import { Stepable } from '../../../components/StepManager/StepManager';
import SecondStepHeader from './header/SecondStepHeader';
import { connect } from 'react-redux';
import { defaultCalculationData } from '../../../../constants/productsDefaultData/employeeHealthcare/defaultData';
import BuyingInformationPanel from '../../../components/BuyingInformationPanel';
import SelfContributionAmountPanel from './SelfContributionPanel';
import { updateCalculationData } from '../../../../selectors/employeeHealthcare/updateSelector';
import useNextRenderCall from '../../../../hooks/useNextRenderCall';
import PricePanel from '../../../components/PricePanel/PricePanel';
import { setSummaryData } from '../../../../actions/summary-actions';
import {
    fetchBuyCalculationData,
    fetchUpdateCalculationData
} from '../../../../epics/calculation-data';
import { CoverageDetails } from './CoverageDetails/CoverageDetails';
import { InformationPanel } from './InformationPanel/InformationPanel';
import { getText } from '../../../../services/text/text-service';
import { HealthcareCoveragesEnum } from '../../../../types/enums/products/healthcare/coverages';
import useMobile from '../../../../hooks/useMobile';
import {
    createUtagViewData,
    invokeUtagData
} from '../../../../utils/statisticsUtils';
import { StatsDataEnum } from '../../../../types/enums/statsDataEnum';
import {
    resolvePartnerForStats,
    validatePathName
} from '../../../../services/stats/stats-service';

const HEALTHCARE_INSURANCE = 'Sjukvårdsförsäkring';

interface StateToProps {
    calculation: any;
    calculationOut: any;
}

interface DispatchToProps {
    fetchUpdateCalculationData: Function;
    fetchBuyCalculationData: Function;
    setSummaryData: Function;
}

const SecondStep: React.FunctionComponent<Stepable &
    StateToProps &
    DispatchToProps> = ({
    goToNextStep,
    goToPrevStep,
    calculation,
    calculationOut,
    fetchUpdateCalculationData,
    fetchBuyCalculationData,
    setSummaryData
}) => {
    const isMobile = useMobile();

    useEffect(() => {
        const intervalUtag = setInterval(() => {
            //@ts-ignore
            if (window.utag) {
                invokeUtagData(
                    createUtagViewData(
                        StatsDataEnum.APPLICATION_NAME,
                        'employeeHealthCare',
                        resolvePartnerForStats(),
                        validatePathName(window.location.pathname) +
                            'sjukvardsforsakring/' +
                            StatsDataEnum.OFFER,
                        StatsDataEnum.PAGE_TITLE,
                        'sjukvardsforsakring',
                        StatsDataEnum.OFFER
                    )
                );
                clearInterval(intervalUtag);
            }
        }, 500);
    }, []);

    const [paymentTerm, setPaymentTerm] = useState(
        defaultCalculationData.paymentTerm
    );

    const handleMailingChannelChange = (e, onChange) => {
        onChange(e);
        callUpdate();
    };

    // @ts-ignore
    const [deductibleCode, setDeductibleCode] = useState(
        calculation.deductibleCode
    );

    const [selectedCoverage, setSelectedCoverage] = useState(1018);

    const callUpdate = useNextRenderCall(() =>
        fetchUpdateCalculationData(calculation, calculationOut)
    );

    const handlePaymentTermChange = (e, onChange) => {
        onChange(e);
        setPaymentTerm(Number(e.target.value));
        callUpdate();
    };

    const handleDeductibleCodeChange = (e, onChange) => {
        onChange(e);
        setDeductibleCode(e.target.value);
        callUpdate();
    };

    const resolvePricePanelHeader = coverageID => {
        let coverageName = '';
        switch (Number(coverageID)) {
            case HealthcareCoveragesEnum.BASIC:
                coverageName = 'Bas';
                break;
            case HealthcareCoveragesEnum.STANDARD:
                coverageName = 'Lagom';
                break;
            case HealthcareCoveragesEnum.PLUS:
                coverageName = 'Plus';
                break;
        }
        return `${HEALTHCARE_INSURANCE} ${coverageName}`;
    };

    return (
        <div>
            <SecondStepHeader customerName={calculationOut.customerName} />
            <SelfContributionAmountPanel
                handleDeductibleCodeChange={handleDeductibleCodeChange}
                price={calculationOut.premiumList[0].premium}
                paymentTerm={paymentTerm}
            />
            <CoverageDetails
                coverages={calculationOut.premiumList.sort(
                    (a, b) => a.premium - b.premium
                )}
                setSelectedCoverage={setSelectedCoverage}
                paymentTerm={paymentTerm}
            />
            <InformationPanel
                headerText={getText(
                    `webshopsweden.products.employeeHealthcare.informationPanel.header${
                        isMobile ? 'ForMobile' : ''
                    }`
                )}
                helpText={getText(
                    'webshopsweden.products.employeeHealthcare.informationPanel.helpText'
                )}
                leadText={getText(
                    'webshopsweden.products.employeeHealthcare.informationPanel.leadText'
                )}
            />
            <BuyingInformationPanel
                paymentTermChangeHandling={handlePaymentTermChange}
                setPricesForSummaryPage={setSummaryData}
                chosenPrice={calculationOut.premiumList[0].premium}
                initialValues={{
                    startDate: new Date()
                }}
                onSubmit={() => {
                    calculation.customerPhone = calculation.customerPhone.replace(
                        /-|\s/g,
                        ''
                    );
                    fetchBuyCalculationData(
                        { ...calculation, coverageOption: selectedCoverage },
                        calculationOut,
                        goToNextStep
                    );
                }}
                mailingChannelChangeHandling={handleMailingChannelChange}
                goBack={goToPrevStep}
            />
            <PricePanel
                insuranceName={resolvePricePanelHeader(selectedCoverage)}
                paymentTerm={paymentTerm}
                insurancePrice={
                    calculationOut.premiumList.find(
                        value => selectedCoverage == value.coverageProduct
                    ).premium
                }
            />
        </div>
    );
};

const mapStateToProps = state => ({
    ...updateCalculationData(state)
});

export default connect<StateToProps, any, any>(mapStateToProps, {
    fetchUpdateCalculationData,
    fetchBuyCalculationData,
    setSummaryData
})(SecondStep);
